import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import sort from 'bcl/helpers/sort';
import eq from 'ember-truth-helpers/helpers/eq';
import type ProductGroupModel from 'bcl/models/product-group';

interface InputSelectProductgroupSignature {
  // The arguments accepted by the component
  Args: {
    onChange?: (model: ProductGroupModel) => void;
    hasAllOption: boolean;
    label: string;
    name: string;
    value: ProductGroupModel | null;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class InputSelectProductgroupComponent extends Component<InputSelectProductgroupSignature> {
  <template>
    <div
      class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
    >
      <label
        for={{@name}}
        class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
      >{{@label}}</label>
      <div class="mt-2 sm:col-span-2 sm:mt-0">
        <select
          {{on "change" this.change}}
          name={{@name}}
          id={{@name}}
          value={{@value}}
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {{#if @hasAllOption}}
            <option value="" selected={{eq null @value}}>Alle</option>
          {{/if}}
          {{#each (sort this.productGroups "name") as |productGroup|}}
            <option
              value={{productGroup.id}}
              selected={{eq productGroup @value}}
            >{{productGroup.name}}</option>
          {{/each}}
        </select>
      </div>
    </div>
  </template>
  @service store;
  @action
  change(event: Event) {
    if (this.args.onChange) {
      const value = event.target.value;
      if (!value) {
        this.args.onChange(null);
        return;
      }
      const model = this.store.peekRecord(
        'product-group',
        value
      ) as ProductGroupModel;
      this.args.onChange(model);
      // this.args.onChange(...arguments);
    }
  }
  get productGroups() {
    return this.store.peekAll('product-group');
  }
}
